import { createAsyncThunk } from '@reduxjs/toolkit'
import type {DefaultRootState} from './coreReducer'

const stateREHYDRATE: ReturnType<
	typeof createAsyncThunk<Partial<DefaultRootState>, Partial<DefaultRootState>, { state: DefaultRootState }>
> = createAsyncThunk<Partial<DefaultRootState>, Partial<DefaultRootState>, { state: DefaultRootState }>(
	'_internal:state:rehydrate',
	async state => {
		return new Promise<Partial<DefaultRootState>>(resolve => {
			resolve(state)
		})
	},
)

export { stateREHYDRATE }
